import { SectionHead } from "../components/SectionHead";
import { copy } from "../content/copy";
import { problems } from "../content/problems";

export function ProblemSection() {
  return (
    <section className="section problem" id="problem">
      <div className="container">
        <SectionHead
          eyebrow={copy.problem.eyebrow}
          title={
            <>
              Your interview has <span className="serif-italic">nothing</span> to do with the job.
            </>
          }
          lede={copy.problem.lede}
        />
        <div className="problem-grid">
          {problems.map((p) => (
            <article key={p.tag} className="card problem-card">
              <span className="problem-card__tag">{p.tag}</span>
              <h3 className="problem-card__title">{p.title}</h3>
              <p className="problem-card__body">{p.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
